<div class="body">
  <div class="container">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Parametrizar <span class="txtbienvenida-2">
        Burós De Crédito</span></h3>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-sm-12 mt-3">
        <p class="title-box">*Desde aquí puedes administrar la parametrización de los burós de crédito</p>
      </div>
    </div>
    <form [formGroup]="buroCreditoForm">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped table-borderless rounded">
            <thead class="table_head">
              <tr>
                <th scope="col" class="no-styles table-header" id="habilitado">¿Deseas parametrizar este buró?</th>
                <th scope="col" class="no-styles table-header" id="consultaSeleccionada">Consulta Seleccionada</th>
                <th scope="col" class="no-styles table-header" id="puntajeNatural">Puntaje Mínimo Natural</th>
                <th scope="col" class="no-styles table-header" id="puntajeNaturalInformal">Puntaje Mínimo Natural Informal</th>
                <th scope="col" class="no-styles table-header" id="puntajeJuridica">Puntaje Mínimo Jurídica</th>
              </tr>
            </thead>
            <tbody formArrayName="configuraciones">
              @for (configuracion of configuraciones.controls; track configuracion; let i = $index) {
                <tr [formGroupName]="i">
                  <td>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" formControlName="habilitado" [value]="true"
                        />
                        <label for="Sí" class="form-check-label"> Sí </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" formControlName="habilitado" [value]="false"
                          />
                          <label for="No" class="form-check-label"> No </label>
                        </div>
                      </td>
                      <td>
                        <input formControlName="nameConsulta" class="form-control" readonly>
                      </td>
                      <td>
                        <input class="form-control" formControlName="puntMinScorePn" type="number" min="0" appOnlyNumbers appBloquearPegadoNegativo
                          [readonly]="!configuracion.get('habilitado')?.value">
                        </td>
                        <td>
                          <input class="form-control" formControlName="puntMinScorePnf" type="number" min="0" appOnlyNumbers appBloquearPegadoNegativo
                            [readonly]="!configuracion.get('habilitado')?.value">
                          </td>
                          <td>
                            <input class="form-control" formControlName="puntMinScorePj" type="number" min="0" appOnlyNumbers appBloquearPegadoNegativo
                              [readonly]="!configuracion.get('habilitado')?.value">
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row justify-content-md-center">
                  <div class="col-12 col-lg-3 col-md-2 container-btn">
                    <button class="btn btn-primary hvr-shrink" type="button" (click)="guardar()">
                    Guardar parametrización</button>
                  </div>
                  <div class="col-12 col-md-2 container-btn">
                    <button class="btn  btn-primary hvr-shrink" routerLink="/intermediario/home">
                      Volver
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="footer-body"></div>
            <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
